import React, { Fragment } from 'react';
import './button.scss';

const EdenredButton = ({
	btnType,
	type = 'primary',
	children,
	onPress,
	onClick,
	disabled = false,
	loading,
	icon = null,
	style = {},
	noShadow = false,
	className = '',
}) => {
	const renderButton = () => (
		<button
			type={btnType}
			onClick={onClick}
			className={`${className} edenRedButton ${type} ${loading ? 'loading disablebutton' : ''} ${noShadow ? 'noShadow' : ''}`}
			disabled={disabled}
			loading={loading}
			style={style}>
			{!loading ? (
				<>
					{icon ? <div style={{ marginRight: 5 }}> {icon} </div> : null}
					{children}
				</>
			) : (
				<span className="loader" />
			)}
		</button>
	);

	return <Fragment>{renderButton()}</Fragment>;
};

export default EdenredButton;
